import { createRoot } from "react-dom/client"
import { ConfirmDialog } from "@/components/admin/ConfirmDialog"

type AskConfirmOptions = {
  title: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
}

/**
 * Confirmación accesible para código que no es un componente (hooks, tours, utilidades) y
 * que antes usaba `window.confirm()`. Devuelve true si el usuario confirma. No es destructiva,
 * así que el botón de confirmar usa el estilo primario.
 */
export function askConfirm({ title, message, confirmLabel = "Continuar", cancelLabel = "Ahora no" }: AskConfirmOptions): Promise<boolean> {
  return new Promise((resolve) => {
    const host = document.createElement("div")
    document.body.appendChild(host)
    const root = createRoot(host)

    const close = (answer: boolean) => {
      root.unmount()
      host.remove()
      resolve(answer)
    }

    root.render(
      <ConfirmDialog
        isOpen
        danger={false}
        title={title}
        message={message}
        confirmLabel={confirmLabel}
        cancelLabel={cancelLabel}
        onConfirm={() => close(true)}
        onCancel={() => close(false)}
      />,
    )
  })
}
